<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="fieldTypes"
      :typeslabel="{
        date: '최초 작성일',
        updated_at: '최종 수정일',
      }"
    />

    <!-- List -->
    <div>
      <table-stock v-for="(stock, stock_i) in stockTitles" :key="`table_${stock}`" :isPrint="isPrint" :readonly="board.readonly || readonlyYear" :title="stock" v-model="form[`stockList${stock_i + 1}`]" class="mt-5" />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-5" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableStock from "@/components/TableStock.vue";
import moment from "moment";

export default {
  components: {
    TableStock,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
  },
  data() {
    return {
      readonlyYear: false,
      stockTitles: ["소화기계약", "호흡기계약", "근육이완제(파스, 스프레이)", "상처치료, 기타", "의약외품", "영양제", "진통해열제", "연고류", "기타소모품", "기타"],
      form: {
        headerYear: moment(new Date()).format("YYYY"),
        headerMonth: moment(new Date()).format("MM"),
        headerDate: '',
        headerDateString: '',
        stdInfo: {},

        stockList1: [],
        stockList2: [],
        stockList3: [],
        stockList4: [],
        stockList5: [],
        stockList6: [],
        stockList7: [],
        stockList8: [],
        stockList9: [],
        stockList10: [],

        fileList: [],
      },
    };
  },
  computed: {
    fieldTypes() {
      return ["field_name", "department", "com_name", "rank", "writer_name", "date", "updated_at"];
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    postList() {
      return [...JSON.parse(JSON.stringify(this.$store.state.board.list))].reverse();
    },
    isPostId() {
      return !!this.$route.params.postId;
    },
  },
  watch: {
    'header.year' (value) {
      this.form.headerYear = value;
    },
    'header.month' (value) {
      this.form.headerMonth = value > 9 ? value : `0${value}`;
    },
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    'form.headerYear' : {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerDate = `${this.form.headerYear}-${this.form.headerMonth}-01`
        this.form.headerDateString = `${this.form.headerYear}년 ${this.form.headerMonth}월`
      }
    },
    'form.headerMonth' : {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerDate = `${this.form.headerYear}-${this.form.headerMonth}-01`
        this.form.headerDateString =  `${this.form.headerYear}년 ${this.form.headerMonth}월`
      }
    },
  },
  methods: {
    formatMonth() {
      this.form.headerMonth = String(this.form.headerMonth).padStart(2, '0');
    }
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

input[type="number"] {
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.7rem !important;
  transition: all 0.3s ease;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
